import { Button, ButtonGroup, ContentCard, TinyTitle } from '@indigo-ag/component-module';
import { CropCashFlow } from '@indigo-ag/schema';
import i18next from 'i18next';
import React, { useState } from 'react';
import { NoResultsFound } from 'shared/components/NoResultsFound/NoResultsFound';
import styled from 'styled-components';

import { CropCashFlowDetailsGrid } from './CropCashFlowDetailsGrid';
import { CropCashFlowNotes } from './CropCashFlowNotes';
import { getTranslatedCropName } from './utils/decisionSheet.util';

const CropCashFlowContentCard = styled.div`
  padding-top: 16px;
  margin: 16px 0;
  border-bottom: 1px solid rgba(210, 211, 215, 0.3);
`;

const CropWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const CropImage = styled.img`
  border-radius: 50%;
  height: 1.4rem;
  width: 1.4rem;
  margin-right: 8px;
`;

const PAGE_SIZE = 3;

const getCropIcon = (cropName: string) => {
  switch (cropName.toLowerCase()) {
    case 'corn':
      return require('../../../../assets/images/CORN_YELLOW_1x.png');
    case 'winter wheat':
      return require('../../../../assets/images/WINTER_WHEAT_1x.png');
    case 'spring wheat':
      return require('../../../../assets/images/SPRING_WHEAT_1x.png');
    case 'soybean':
      return require('../../../../assets/images/SOYBEANS_1x.png');
    case 'oats':
      return require('../../../../assets/images/OATS_1x.png');
    case 'sorghum':
      return require('../../../../assets/images/SORGHUM_1x.png');
    case 'cotton':
      return require('../../../../assets/images/COTTON_1x.png');
    case 'rice':
      return require('../../../../assets/images/RICE_1x.png');
    default:
      return undefined;
  }
};

interface CropCashFlowListProps {
  cropCashFlows?: CropCashFlow[] | null;
}

export const CropCashFlowList = ({ cropCashFlows }: CropCashFlowListProps) => {
  const [page, setPage] = useState(1);
  const [displayedResults, setDisplayedResults] = useState<CropCashFlow[]>(
    cropCashFlows?.length ? cropCashFlows.slice(0, Math.min(cropCashFlows.length, PAGE_SIZE)) : []
  );

  return (
    <ContentCard titleText={i18next.t('cropCashFlow')}>
      {!cropCashFlows ? (
        <>{i18next.t('couldntFetchData')} </>
      ) : cropCashFlows.length === 0 ? (
        <NoResultsFound letMeMargin />
      ) : (
        <>
          {displayedResults?.map((cropCashFlowItem, index) => {
            const cropIcon = getCropIcon(cropCashFlowItem.crop ?? '');
            return (
              <CropCashFlowContentCard key={cropCashFlowItem.crop + index}>
                <CropWrapper>
                  {cropIcon && <CropImage src={cropIcon} alt={cropCashFlowItem.crop} />}
                  <TinyTitle>{getTranslatedCropName(cropCashFlowItem.crop).toUpperCase()}</TinyTitle>
                </CropWrapper>
                <CropCashFlowDetailsGrid cropCashFlowItem={cropCashFlowItem} />
                <CropCashFlowNotes notes={[]} />
              </CropCashFlowContentCard>
            );
          })}
          <ButtonGroup style={{ marginTop: '16px' }}>
            {displayedResults.length < cropCashFlows.length && (
              <Button
                onClick={() => {
                  setPage(page + 1);
                  setDisplayedResults(cropCashFlows.slice(0, page * PAGE_SIZE + 1));
                }}
              >
                {i18next.t('showMore')}
              </Button>
            )}
          </ButtonGroup>
        </>
      )}
    </ContentCard>
  );
};
